import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["action"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", { type: "submit" }, "次へ", -1)
const _hoisted_3 = [
  _hoisted_2
]

import { inject, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import { Auth, DataStore, Hub } from 'aws-amplify';

import oauthProd from '../aws-oauth-config.prod'
import oauthStg from '../aws-oauth-config.stg'

import { Member } from '@/models';
import { cookie } from '@liff/util';
import { useCookies } from 'vue3-cookies';


export default /*#__PURE__*/_defineComponent({
  emits: ['stopLoading'],
  setup(__props, { emit }) {

Auth.configure({ oauth: process.env.ENV == 'prod' ? oauthProd : oauthStg })

const router = useRouter();
const route = useRoute();

const {cookies} = useCookies();

const api: any = inject('api');



const testUrl = ref<any>('');
const qrform = ref();

const initDataStore = async() => {
  testUrl.value = process.env.BACK_URL;
  console.log('DataStore start...');
  await DataStore.clear();
  try {

    await Hub.listen('datastore', async (data) => {
      console.log('DataStore listen');
      console.log(data.payload.event);
      
      if (data.payload.event === 'ready') {
        const token = cookie.get('token');

        console.log('DataStore ready');

        if (token) {
          console.log(token);
          await redirectToDeviceApp(token);
        }
        else {
          await redirectToHome();
        }
      }
    });
    await DataStore.start();

  }
  catch(e) {
    console.log(e);
  }
}

onMounted(async() => {
  const query: any = route.query;

  if (query && query['shopid']) {
    const shopId: any = query['shopid'];
    cookies.set('shopId', shopId);
  }

  const user = await Auth.currentAuthenticatedUser();
  
  if (user) {
    await initDataStore();
  }
  else {
    await Hub.listen('auth', async (data) => {
      switch (data.payload.event) {
        case "signIn": {
          const cognitoUser = await Auth.currentAuthenticatedUser();
          console.log(`signed in ... ${cognitoUser.username}`);
          await initDataStore();
          break;
        }
      }
    });
  }

});

const redirectToDeviceApp = async(token: string) => {
  try {
    const authSession = await Auth.currentSession();
    const cogToken = authSession.getAccessToken().getJwtToken();

    const user = await Auth.currentAuthenticatedUser();
    const buf = (await DataStore.query(Member, (m) => m.cogUser('eq', user.username)));

    const res = await api.updateMachineSession(token, buf.length > 0 ? buf[0].id : null, cogToken);

    console.log(res);

    const url = process.env.MOBILE_BACK_URL + '/payment?token=' + token;

    location.href = url;
  }
  catch(e) {
    console.log(e);
  }
}

const redirectToHome = async() => {
  location.href = testUrl.value;
  /*if(!window.open(url, '_blank')) {
    qrform.value.submit();
  }
  emit('stopLoading');*/
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", {
      ref_key: "qrform",
      ref: qrform,
      action: testUrl.value,
      method: "get",
      target: "_blank"
    }, _hoisted_3, 8, _hoisted_1)
  ]))
}
}

})